export var defaultBackgroundColor = '#FFFFFF';
export var defaultBackgroundRepeat = 'repeat';
export var defaultContainerElements = [
    'ul',
    'li',
    'h1',
    'h2',
    'h3',
    'p',
    'span',
];
export var defaultDividerName = 'divider1';
export var defaultDividerRole = 'divider';
export var defaultLineHeight = 1;
export var defaultLink = 'https://wix.com';
export var defaultTextColor = '#000000';
export var defaultTextPadding = '18px';
export var defaultTextSize = 14;
export var defaultBreakpoint = '480px';
export var defaultButtonPadding = '10px 25px';
export var defaultButtonPaddingObject = {
    top: '10px',
    right: '25px',
    bottom: '10px',
    left: '25px',
};
export var buttonMobileBreakpoints = [
    '480px',
    '420px',
    '400px',
    '360px',
    '320px',
];
export var mobileFullWidthColumnClassName = 'html-column-mobile-full-width';
export var mobileNoWrapColumnClassName = 'html-column-width-mobile-no-wrap';
//# sourceMappingURL=defaults.js.map